import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { cn } from '../lib/utils';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Nosotras',
    href: '#nosotras'
  }, {
    name: 'Horarios',
    href: '#horarios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'glass-nav py-3 shadow-sm' : 'bg-transparent py-5')} data-id="element-114">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between" data-id="element-115">
        <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-116">
          <Logo data-id="element-117" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-118">
          <ul className="flex items-center gap-6" data-id="element-119">
            {navLinks.map(link => <li key={link.name} data-id="element-120">
                <a href={link.href} className="text-sm font-medium text-brand-dark/80 hover:text-brand-magenta transition-colors" data-id="element-121">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#contacto" className="bg-gradient-brand text-white px-6 py-2.5 rounded-full text-sm font-medium hover:scale-105 transition-transform shadow-md shadow-brand-pink/20" data-id="element-122">
            Reservá tu turno
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-brand-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-123">
          {isMobileMenuOpen ? <X size={24} data-id="element-124" /> : <Menu size={24} data-id="element-125" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 py-4 px-6 flex flex-col gap-4" data-id="element-126">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-brand-dark py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-127">
              {link.name}
            </a>)}
          <a href="#contacto" className="bg-gradient-brand text-white px-6 py-3 rounded-full text-center font-medium mt-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-128">
            Reservá tu turno
          </a>
        </div>}
    </header>;
};